<app-shared-modal-header
  [applyTitle]="modalTitle"
  [isCloseIconVisible]="true"
  (emitClose)="onCancelClick()">
</app-shared-modal-header>

@if (debtorData) {
  <div class="debtor-form-wrapper">
    <form class="debtor-form">
      <!-- Debtor Information Section -->
      <section class="block debtor-info">
        <h3>Debtor Information</h3>
        <div class="field">
          <label>Account Number</label>
          <div class="account-div">
            <div class="fake-input">
              {{ debtorData.account }}
              <app-shared-button (buttonClicked)="onDebtorChangeClick()"> Change Debtor</app-shared-button>
            </div>

          </div>

        </div>

        <div class="field">
          <label>Name</label>
          <input
            [(ngModel)]="debtorData.name"
            name="name"
            placeholder="Enter name"
            type="text">
        </div>

        <div class="field">
          <label>Contact</label>
          <input
            [(ngModel)]="debtorData.contact"
            name="contact"
            placeholder="Enter contact name"
            type="text">
        </div>

        <div class="field">
          <label>Address Line 1</label>
          <input
            [(ngModel)]="debtorData.address1"
            name="address1"
            placeholder="Enter address line 1"
            type="text">
        </div>

        <div class="field">
          <label>Address Line 2</label>
          <input
            [(ngModel)]="debtorData.address2"
            name="address2"
            placeholder="Enter address line 2"
            type="text">
        </div>

        <div class="field">
          <label>Address Line 3</label>
          <input
            [(ngModel)]="debtorData.address3"
            name="address3"
            placeholder="Enter address line 3"
            type="text">
        </div>

        <div class="field">
          <label>Address Line 4</label>
          <input
            [(ngModel)]="debtorData.address4"
            name="address4"
            placeholder="Enter address line 4"
            type="text">
        </div>

        <div class="field">
          <label>Telephone Number</label>
          <input
            [(ngModel)]="debtorData.telephone1"
            name="telephone1"
            placeholder="Enter telephone number"
            type="tel">
        </div>

        <div class="field">
          <label>Email</label>
          <input
            [(ngModel)]="debtorData.email"
            name="email"
            placeholder="Enter email address"
            type="email">
        </div>

        <div class="field">
          <label>Tax Number</label>
          <input
            [(ngModel)]="debtorData.taxNo"
            name="taxNo"
            placeholder="Enter tax number"
            type="text">
        </div>
      </section>

      <!-- Quote Information Section -->
      <section class="block quote-info">
        <h3>Quote Information</h3>
        <div class="field">
          <label>Quote Discount (%)</label>
          <input
            [(ngModel)]="debtorData.discount"
            name="discount"
            placeholder="0"
            type="number">
        </div>

        <div class="field">
          <label>Quote Date</label>
          <input
            [(ngModel)]="today"
            name="quoteDate"
            disabled>
        </div>

        <div class="field">
          <label>Order Number</label>
          <input
            [(ngModel)]="debtorData.orderNumber"
            name="orderNumber"
            placeholder="Enter order number"
            type="text">
        </div>

        <div class="field">
          <label>Rep Number</label>
          <input
            [(ngModel)]="debtorData.cellphone"
            name="cellphone"
            placeholder="Enter rep number"
            type="text">
        </div>
      </section>

      <!-- Delivery Information Section -->
      <section class="block delivery-info">
        <h3>Delivery Information</h3>
        <div class="field">
          <label>Delivery Note</label>
          <textarea
            [(ngModel)]="debtorData.deliveryNote"
            name="deliveryNote"
            placeholder="Enter delivery notes"
            rows="4">
          </textarea>
        </div>
      </section>
    </form>

    <footer class="form-actions">
      <button
        (click)="onCancelClick()"
        class="secondary-btn"
        type="button">
        {{ buttonCloseText }}
      </button>
      <button
        (click)="onSaveClick()"
        class="primary-btn"
        type="button">
        {{ buttonAcceptText }}
      </button>
    </footer>
  </div>
}
